import '@babel/polyfill'
import 'get-root-node-polyfill/implement'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './plugins'
import router from './router'
// import './services/sentry'

Vue.config.productionTip = false

// eslint-disable-next-line no-unused-vars
const routerBefore = (to, from, next) => {
  const { state } = store
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!state.loggedIn) {
      next({
        path: '/',
      })
    } else {
      next()
    }
  } else {
    next()
  }
}

export async function createApp({
  beforeApp = () => {},
  afterApp = () => {},
} = {}) {
  await beforeApp({
    router,
    store,

  })

  // TODO не забыть это вернуть
  router.beforeEach(routerBefore)

  const app = new Vue({
    store,
    router,
    render: h => h(App),
  })

  const result = {
    app,
    router,
    store,

  }

  await afterApp(result)

  return result
}
